const appConfig = {
    appId: "anotificationsQore-b4d7b6b9-ac2b-47b7-afc1-b2f83fb3626a",
    appName: "Notify",
    site: 'notifications-qore',
    icon: "https://nsdstaticasset.blob.core.windows.net/assets/Qore_Brand_Icons/notificationsQoreAppIcon.png"
};

export default appConfig;
